import React from 'react'
import { SAVE_CUSTOMER_KYC, NEW_KYC_TITLE, NO, SUBMIT, YES, GO_BACK, DONE } from '../../config/constant';
import {SV_API_BASE_URL} from '../../config/api_endpoint'
import "../../assets/css/kycapp.css";
import { doPost } from '../../service';
import ModalPopUp from '../ModalPopUp';
import Dropdown from '../Dropdowns';

export default function CustomerDetails() {
    const custNumber = new URLSearchParams(window.location.search).get('customerNumber');

    return <CustomerDetailsComponent custNumber={parseInt(custNumber)} />
}

export class CustomerDetailsComponent extends React.Component {

    constructor(props) {
        super(props)
        this.videoRef = React.createRef();
        this.photoRef = React.createRef();
        this.savedPhoto = React.createRef();
        this.savePhotoDiv = React.createRef();
        this.savePhotoTextDiv = React.createRef();
        this.currentDate = new Date().toLocaleString().replace(",","");
        this.state = {
            hasPhoto: false,
            onFocus: "DocumentType",
            isLoading: false,
            buttonEnabled: false,
            isModalOpen: false,
            isModalThanksOpen: false,
            isModalShowError: false,
            DocumentType : "Aadhaar",
            DocumentNumber : "",
            CreatedOn : this.currentDate,
            errorMessage: "",
            KycDetails: {
                CustomerKycPhoto:"",
            },
            TypeofIds: [],
            FamilyMembers: [],
            CustomerInformation: [],
            customerDetailsInfo: {
                CustId:"",
                CustomerNumber : "",
                CustomerName : "",
                CustomerDateofBirth: "",
                CustomerAddress: "",
                CustomerPincode: "",
                CustomerState: "",
                CustomerMobile: "",
                CustomeridCardNumber: "",
                CustomerFathersName: "",
                CustomerRvPersonId: "",
                FamilyMemberName: "",
                FamilyMemberCustomerRelationship: ""
            }
        }
    }

    componentDidMount() {
        this.setState({ onFocus: "DocumentType" })
        this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, CustomerNumber: this.props.custNumber } }));
        this.fetchCustomerTypeOfIds();
        this.fetchCustomerInformation();
        this.fetchKycByCustomerNumber();
    }

    fetchCustomerInformation = async () => {
        try {
            const custNumber = this.props.custNumber;
            const custResponse = await fetch(SV_API_BASE_URL +'GetCustomerInformation?CustomerNumber=' + custNumber);
            const custData = await custResponse.json();
            this.setState({ CustomerInformation: custData });
            let familyMembers = [{Key:"00000000-0000-0000-0000-000000000000", Value:"N/A"}];

            if(custData)
            {
                custData.map(item=>{
                    item.family.map((familyMember, index)=> {
                        if(item.customerrvpersonid===familyMember.familymemberid)
                        {
                            this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, FamilyMemberName: familyMember.familymembername } }));
                            this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, FamilyMemberCustomerRelationship: familyMember.familymembercustomerrelationship } }));
                        }

                        familyMembers.push({Key:familyMember.familymemberid, Value:familyMember.familymembername + " - " + familyMember.familymembercustomerrelationship});
                    });
                    this.setState({FamilyMembers: familyMembers});
                    this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, CustomerName: item.customername } }));
                    this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, CustomerDateofBirth: item.customerdateofbirth } }));
                    this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, CustomerAddress: item.CustomerAddress } }));
                    this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, CustomerPincode: item.customerpincode } }));
                    this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, CustomerState: item.customerstate } }));
                    this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, CustomerMobile: item.customermobile } }));
                    this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, CustomeridCardNumber: item.customeridcardnumber } }));
                    this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, CustomerFathersName: item.customerfathersname } }));
                    this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, CustomerRvPersonId: item.customerrvpersonid } }));
        
                });
            }

        } catch (error) {
            console.error(error);
        }
    }

    fetchCustomerTypeOfIds = async () => {
        try {
            const kycTypeResponse = await fetch(SV_API_BASE_URL +'TypesofIds');
            const kycTypeData = await kycTypeResponse.json();
            let typeofIds = []

            kycTypeData.map(item => {
                typeofIds.push({Key:item.TypeName, Value:item.TypeName});
            })
            this.setState({ TypeofIds: typeofIds });
        } catch (error) {
            console.error(error);
        }
    }

    fetchKycByCustomerNumber = async () => {
        try {
            const custNumber = this.props.custNumber;
            const kycResponse = await fetch(SV_API_BASE_URL +'GetKycByCustomerNumber/?CustomerNumber=' + custNumber);
            const kycData = await kycResponse.json();
            const {CreatedOn } = this.state;
            
            kycData.map(item => {
                this.setState(prevState => ({ KycDetails: { ...prevState.KycDetails, CustomerKycPhoto: item.img} }));
                this.setState(prevState => ({ DocumentType : item.DocumentType} ));
                this.setState(prevState => ({ DocumentNumber : item.DocumentNumber} ));
                this.setState(prevState => ({ CreatedOn : item.CreatedOn} ));

                this.savePhotoDiv.current.style.display = "block";
                this.savePhotoTextDiv.current.style.display = "block";
            });

        } catch (error) {
            console.error(error);
        }
    }

    getVideo = () => {
        navigator.mediaDevices.getUserMedia({
            video: {width: { ideal: 2160 },
            height: { ideal: 4096 }, facingMode: 'environment' }
        })
        .then(stream => {
            let video = this.videoRef.current;
            let canvas = this.photoRef.current;
            video.srcObject = stream;
            video.play();
            video.onloadedmetadata = () => {
                canvas.width = 1280;
                canvas.height = 720;
            };
        })
        .catch(err =>{
            console.error(err);
        })
    }
      
    delay = ms => new Promise(res => setTimeout(res, ms));

    takePhoto = () =>{
        // const width = 414;
        // const height = width / (16/9);

        let video = this.videoRef.current;
        let canvas = this.photoRef.current;

        const top  = Math.ceil((video.videoHeight * (7.64)) /100)
        const width  = Math.ceil((video.videoWidth * (73.24)) /100 )

        //photo.width = width;
        //photo.height= height;
        
        console.log("canvas.width = " + canvas.width)
        console.log("canvas.height = " + canvas.height)
        console.log("video.width = " + video.width)
        console.log("video.height = " + video.height)
        console.log("video.videoWidth = " + video.videoWidth)
        console.log("video.videoHeight = " + video.videoHeight)
        console.log("top = " + top)
        console.log("width = " + width)
        let ctx = canvas.getContext('2d');

        ctx.drawImage(video,0,0,video.videoWidth, video.videoHeight,0,0,1280,720 )
        //ctx.drawImage(video,top,0,width,video.videoHeight,0,0,video.videoWidth,video.videoHeight)
        //ctx.drawImage(video, top, 0, width, video.height, 0, 0, video.width, video.height)
        //ctx.drawImage(video,video.offsetWidth, video.offsetHeight)
        //ctx.drawImage(video,165,0,3000,2160,0,0,4096,2160)
        //ctx.drawImage(video,  0,0,canvas.width, canvas.height)
        //ctx.scale(-1, 1);
        //ctx.drawImage(video, video.width * -1, 0, photo.width, photo.height);

        var myImage = canvas.toDataURL("image/jpeg"); 
        //ctx.clearRect(0,0, photo.width, photo.height);

        this.setState(prevState => ({ KycDetails: { ...prevState.KycDetails, CustomerKycPhoto: myImage } }));
        
        this.setState({ hasPhoto: false })

        video.srcObject = null;
        this.delay(5).then(ms => {
            this.savePhotoDiv.current.style.display = "block";
            this.savePhotoTextDiv.current.style.display = "block";
        })
    }
    
    startCamera = () =>{
        this.getVideo();
        //setInterval(this.takePhoto, 10000); 
        this.setState({ hasPhoto: true })
        this.savePhotoDiv.current.style.display = "none";
        this.savePhotoTextDiv.current.style.display = "none";
    };

    verifyData = () => {
        const { DocumentType, DocumentNumber } = this.state;
        const {CustomerKycPhoto} = this.state.KycDetails;
        let {onFocus, errorMessage} = this.state;

        if (CustomerKycPhoto === '' || CustomerKycPhoto === ' ') {
            onFocus = "CustomerKycPhoto";
            errorMessage = "Please take photo to save";
            //show error
            this.setState({ onFocus, isModalOpen: false, isModalThanksOpen: false, isModalShowError: true , errorMessage});
            return false
        }

        if (DocumentNumber === '' || DocumentNumber === ' ') {
            onFocus = "DocumentNumber";
            errorMessage = "Please enter valid id for " + DocumentType;
            //show error
            this.setState({ onFocus, isModalOpen: false, isModalThanksOpen: false, isModalShowError: true , errorMessage});
            return false
        }

        this.setState({ isModalOpen: true })
    }

    conform = () => {
        const { DocumentType, DocumentNumber, CreatedOn} = this.state;
        const { CustomerNumber, CustomerRvPersonId} = this.state.customerDetailsInfo;
        const {CustomerKycPhoto} = this.state.KycDetails;

        const callback = (isSuccess, CustId) => {
            if (isSuccess) {
                this.setState({ isModalOpen: false, isModalThanksOpen: true })
                this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, CustId: CustId } }));
                window.myGlobalCounter =  0;
            }
            else {
                //show error
                this.setState({ isModalOpen: false, isModalThanksOpen: false, isModalShowError: true })
            }
        }

        let params = {
            CustomerNumber: CustomerNumber,
            CustomerRvPersonId: CustomerRvPersonId,
            DocumentType: DocumentType,
            DocumentNumber: DocumentNumber,
            ImgSrc: CustomerKycPhoto
        }

        this.saveCustomerKyc(params, callback);
    }

    saveCustomerKyc(CustomerDetailsParams, callback) {
        try {
            doPost(SAVE_CUSTOMER_KYC, CustomerDetailsParams).then(
                function (results) {
                    const CustId = results.CustId;
                    callback(true, CustId);
                }
            );
        }
        catch (error) {
            callback(false, "");
        }
    }

    goBack = () => {
        this.setState({ isModalOpen: false, isModalShowError: false, errorMessage: ""})
    }

    done = () => {
        this.setState({ isModalThanksOpen: false })
    }

    handleFocus = (onFocusName) => {
        this.setState({ onFocus: onFocusName })
    };

    onChangeValue = (e) => {
        const value = e.target.value;
        const { onFocus } = this.state;

        if(onFocus==="DocumentType")
        {
            this.setState({DocumentType: value});
            //this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, MaxLoanAmountforSvasti: parseInt(value) }, }), () => this.onChange());
        }

        if(onFocus==="DocumentNumber")
        {
            this.setState({DocumentNumber: value});
            //this.setState(prevState => ({ customerDetailsInfo: { ...prevState.customerDetailsInfo, MaxLoanAmountforSvasti: parseInt(value) }, }), () => this.onChange());
        }
        
    }

    onChange = (e) => {
        const { CustomerNumber } = this.state.customerDetailsInfo;
        let { buttonEnabled } = this.state;

        if (CustomerNumber !== '') {
            buttonEnabled = true;
        } else {
            buttonEnabled = false;
        }
        this.setState({ buttonEnabled });
    }

    onSubmit = (e) => {
        e.preventDefault();
        console.log(this.state.customerDetailsInfo);
    };

    render() {
        let { CustomerNumber, CustId, CustomerName, CustomerDateofBirth, CustomerPincode, CustomerState, CustomerMobile, CustomerRvPersonId, FamilyMemberName, FamilyMemberCustomerRelationship } = this.state.customerDetailsInfo;
        const {CustomerKycPhoto} = this.state.KycDetails;
        const {TypeofIds, DocumentType, hasPhoto, DocumentNumber} = this.state;

        let {isModalOpen, isModalThanksOpen, isModalShowError, errorMessage } = this.state;
        
        const cssFormClass = "text-sm text-gray-700 w-full mr-3 py-5 px-4 h-2 border-gray-200 rounded mb-2";
        const cssFormClassDisabled = "opacity-60 text-sm  w-full mr-3 py-5 px-4 h-2 border-gray-200 rounded mb-2";
        const cssForDropdown = "inputConsent text-sm text-gray-700 w-full mr-3 py-2 px-4  border-gray-200 rounded mb-2";
        const script = 'if (typeof svastirv !== "undefined" && typeof svastirv.rvKycCapture === "function") {svastirv.rvKycCapture("Success");}';
        return (
            <div className="flex flex-col justify-center items-center">
                
                <div className="top-text p-1">
                    <img className="mx-auto h-16 w-32" src={require("../../assets/images/svasti_logo.png")} alt="images" />
                </div>
                <div className="top-text p-1">
                    <span className='font-serif text-2xl '> RV Person KYC Capture </span>
                </div>
                
                <table className="md:table-fixed">
                    <tbody>
                        <tr>
                            <td className="p-1"><span className='font-serif text-l font-black'>Customer Number</span></td>
                            <td className="p-1" colSpan="2"><input type="text" name="CustomerNumber" id="CustomerNumber" className={cssFormClassDisabled} value={CustomerNumber} readOnly /></td>
                        </tr>
                        <tr>
                            <td className="p-1"><span className='font-serif text-l font-black'>Customer Name</span></td>
                            <td className="p-1" colSpan="2"><input type="text" name="CustomerName" id="CustomerName" className={cssFormClassDisabled} value={CustomerName} readOnly /></td>
                        </tr>
                        <tr>
                            <td className="p-1"><span className='font-serif text-l font-black'>Family Member Name</span></td>
                            <td className="p-1" colSpan="2"><input type="text" name="FamilyMemberName" id="FamilyMemberName" className={cssFormClassDisabled} value={FamilyMemberName} readOnly /></td>
                        </tr>
                        <tr>
                            <td className="p-1"><span className='font-serif text-l font-black'>Relationship</span></td>
                            <td className="p-1" colSpan="2"><input type="text" name="FamilyMemberCustomerRelationship" id="FamilyMemberCustomerRelationship" className={cssFormClassDisabled} value={FamilyMemberCustomerRelationship} readOnly /></td>
                        </tr>
                        <tr>
                            <td className="p-1"><span className='font-serif text-l font-black'>Mobile Number</span></td>
                            <td className="p-1" colSpan="2"><input type="text" name="CustomerMobile" id="CustomerMobile" className={cssFormClassDisabled} value={CustomerMobile} readOnly /></td>
                        </tr>
                        <tr>
                            <td className="p-1"><span className='font-serif text-l font-black'>Document Type</span></td>
                            <td align="left" className="p-1">
                                <Dropdown cssForDropdown={cssForDropdown} idName="DocumentType"
                                    onChangeValue={this.onChangeValue} 
                                    onChangeComponent={DocumentType} 
                                    onFocusName="DocumentType" 
                                    DropdownKeyValuePair={TypeofIds}
                                    onFocusChange={() => this.handleFocus("DocumentType")}
                                    disabledField="" />
                            </td>
                        </tr>
                        <tr>
                            <td className="p-1"><span className='font-serif text-l font-black'>Document Number</span></td>
                            <td className="p-1">
                                <input type="text" 
                                        name="DocumentNumber" 
                                        id="DocumentNumber" 
                                        className={cssFormClass} 
                                        value={DocumentNumber}
                                        onChange={this.onChangeValue} 
                                        placeholder= "Enter Document Number"
                                        onFocus={() => this.handleFocus("DocumentNumber")} 
                                        onClick={() => this.handleFocus("DocumentNumber")}  />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div className="top-text">Version 6.0.0 </div>
                <div className=" w-92 relative flex p-4 text-xl ">Capture RV Person KYC Photo</div>
                <div className=" w-92 relative z-0 flex svastiBackground h-56">
                    <div> <video ref={this.videoRef} width="4096" height="2160"  className=" z-0 w-72 flex h-56"></video></div>
                    
                    <div className='savePhoto absolute svastiBackground w-92 h-56  z-10' ref={this.savePhotoDiv} style={{display:'none'}} >
                        <img src= {CustomerKycPhoto}  ref={this.savedPhoto} alt="Kyc" className=" z-10  w-72  flex h-56"/>
                    </div>
                
                    <div className='savePhotoText absolute w-92 z-10' ref={this.savePhotoTextDiv} style={{display:'none'}} >
                        Photo
                    </div>
        
                </div>
        
                <div className='relative h-26'>
                    {hasPhoto && (<button id="take-photo" onClick={() => this.takePhoto()} > Take<div><div></div></div>Photo</button>)}
                    {!hasPhoto && (<button id="start-camera" onClick={() => this.startCamera()}> Start<div><div></div></div>Camera</button>)}

                </div>

                <div className="w-full lg:w-2/6">
                    <div className='p-4'>
                        
                        <div className="flex items-center justify-between">
                            <button onClick={() => this.verifyData()} type="button" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full mt-4">
                                {SUBMIT}
                            </button>
                        </div>
                    </div>
                </div>

                <ModalPopUp
                    isModalOpen={isModalOpen}
                    title={NEW_KYC_TITLE}
                    body={<span>
                        <span>Update record for Customer {CustomerNumber}?</span><br />
                    </span>}
                    onCancel={() => this.goBack()}
                    cancelButton={NO}
                    onSubmit={() => this.conform()}
                    submitButton={YES} />
                
                <ModalPopUp
                    isModalOpen={isModalThanksOpen}
                    onSubmit={() => this.done()}
                    submitButton={DONE}
                    title={"Record Saved"}
                    body={<>Customer Details has been saved.</>} 
                    script={script}/>

                <ModalPopUp
                    isModalOpen={isModalShowError}
                    onCancel={() => this.goBack()}
                    cancelButton={GO_BACK}
                    title={"Error"}
                    body={<>{errorMessage}<br /></>} />
                    <canvas ref={this.photoRef}></canvas>
            </div>
        );

    }
}


